import Dialog from '@mui/material/Dialog';
import Button from '@mui/material/Button';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';

import DialogNoPin from './components/dialog-no-pin';

import { useErrorStore } from 'store/error';
import { NO_PIN_ERROR } from 'store/error/constants';

import { dialogTextCss, actionButtonCss } from './styles';

const GlobalError = () => {
  const { code, showError, setCloseError } = useErrorStore((state) => state);

  const handleClose = () => {
    setCloseError();
    window.location.reload();
  };

  if (!showError) return null;

  if (code === NO_PIN_ERROR) {
    return <DialogNoPin open={showError} onClose={setCloseError} />;
  }

  return (
    <Dialog open={showError} onClose={setCloseError} fullWidth maxWidth='xs'>
      <DialogContent>
        <DialogContentText className={dialogTextCss}>
          Maaf ya, ada sedikit masalah. Silakan klik "Coba Lagi" untuk tampilkan
          halaman ini, ya!
        </DialogContentText>
        <Button
          variant='contained'
          fullWidth
          onClick={handleClose}
          className={actionButtonCss}
        >
          Coba Lagi
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default GlobalError;
